const PREFIX = "+971 ";

export default function PhoneInput({ value, onChange, placeholder = "50 123 4567", testid, required = false, className = "" }) {
  const handle = (e) => {
    let v = e.target.value;
    if (!v.startsWith(PREFIX)) {
      v = PREFIX + v.replace(/[^\d]/g, "");
    } else {
      v = PREFIX + v.slice(PREFIX.length).replace(/[^\d\s]/g, "");
    }
    onChange(v.slice(0, 17));
  };

  const onKeyDown = (e) => {
    if ((e.key === "Backspace" || e.key === "Delete") && (value || "").length <= PREFIX.length) {
      e.preventDefault();
    }
  };

  const onFocus = () => {
    if (!value) onChange(PREFIX);
  };

  return (
    <input
      type="tel"
      data-testid={testid}
      value={value}
      onChange={handle}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      placeholder={PREFIX + placeholder}
      required={required}
      className={className}
    />
  );
}
